import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Combobox, Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const RegieComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (
		_e: React.SyntheticEvent,
		{ name, value }: { name: string; value: unknown },
	) => onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group>
					<Form.Field
						control={Combobox}
						data-testid="regieDropdown"
						key="identifiantRegie"
						label="Nom de la régie"
						name="identifiantRegie"
						onChange={handleChange}
						options={data?.regies}
						placeholder={data?.identifiantRegie === MULTI ? MULTI : ''}
						search
						selection
						value={data?.identifiantRegie ?? null}
						width={16}
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default RegieComponent;
